import { create } from 'zustand';

const useSortStore = create(
  (set) => ({
    sortOptions: [],
    sortIndex: '',

    setSortInfo: (sortIndex, sortOptions) =>
      set(() => ({ sortIndex, sortOptions })),
  }),
  {
    name: 'sort',
  }
);

export default useSortStore;

export const useSortOptions = () => {
  const sortOptions = useSortStore((state) => state.sortOptions);
  const sortIndex = useSortStore((state) => state.sortIndex);

  return { sortOptions, sortIndex };
};
